import "../css/header.scss";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);
  const [isMoreOpen, setIsMoreOpen] = useState(false);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="header-container">
        <nav className="header-nav">
          <Link to="/shop" className="nav-link" onClick={toTop}>
            Store
          </Link>
          <Link to="/about" className="nav-link" onClick={toTop}>
            About
          </Link>
          <Link to="/contact" className="nav-link" onClick={toTop}>
            Contact
          </Link>
          <div className="more-menu">
            <button
              type="button"
              className="nav-link more-toggle"
              aria-expanded={isMoreOpen}
              aria-controls="policy-menu"
              onClick={() => setIsMoreOpen((open) => !open)}
            >
              More <span aria-hidden="true">⌄</span>
            </button>
            {isMoreOpen && (
              <div className="more-dropdown" id="policy-menu">
                <Link to="/privacy" onClick={() => { setIsMoreOpen(false); toTop(); }}>Privacy</Link>
                <Link to="/cookies" onClick={() => { setIsMoreOpen(false); toTop(); }}>Cookies</Link>
                <Link to="/faqs" onClick={() => { setIsMoreOpen(false); toTop(); }}>FAQs</Link>
                <Link to="/terms" onClick={() => { setIsMoreOpen(false); toTop(); }}>Terms</Link>
                <Link to="/returns" onClick={() => { setIsMoreOpen(false); toTop(); }}>Returns</Link>
                <Link to="/shipping" onClick={() => { setIsMoreOpen(false); toTop(); }}>Shipping</Link>
              </div>
            )}
          </div>
        </nav>
        <div className="header-logo">
          <Link to="/" onClick={toTop} className="brand-mark" aria-label="isanroute home">
            <span className="brand-monogram" aria-hidden="true">i</span>
            <span className="brand-wordmark">isanroute</span>
          </Link>
        </div>
        <div className="header-actions">
          <Link
            to="/cartpage"
            className="action-btn cart-btn"
            onClick={toTop}
            aria-label="Cart"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <path d="M16 10a4 4 0 0 1-8 0"></path>
            </svg>
            {cartItems && cartItems.length > 0 && (
              <span className="cart-count">{cartItems.length}</span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
